import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ProductIncomingModal, { IStateProps, IDispatchProps, IOwnProps } from './ProductIncomingModal'
import {
  DashboardAction,
  requestProductAccept,
} from '../../services/store/actions/dashboard/DashboardAction'

import  { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState, ownProps: IOwnProps): IStateProps {
  const acceptKey = `accept-${ownProps.product.id}`

  return {
    acceptLoading: state.Dashboard.productLoadingStates[acceptKey] || false,
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestProductAccept: (product, onEnd) => dispatch(requestProductAccept({product, onEnd})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ProductIncomingModal)
